import { TTheme } from '@/core/theme'
import GoogleAndMicrosoft from '@assets/images/google-and-microsoft.svg?react'
import { styled } from '@mui/system'

export const TopSectionWrapper = styled('div')`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

export const Left = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

export const StyledGoogleAndMicrosoft = styled(GoogleAndMicrosoft)<{
    theme?: TTheme
}>`
    color: ${({ theme }) => theme.colors.semantic.googleAndMicrosoftIcon};
`
